import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=4649d533&scoped=true"
import script from "./AppToolbar.vue?vue&type=script&lang=js"
export * from "./AppToolbar.vue?vue&type=script&lang=js"
import style0 from "./AppToolbar.vue?vue&type=style&index=0&id=4649d533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4649d533",
  null
  
)

export default component.exports